import type { AssetView } from "../../api/AssetView";

type Slot = NonNullable<AssetView["slot"]>;

// Цвет ветки магазина: рамка иконки предмета и полоска в легенде.
export const SLOT_COLORS: Record<Slot, { border: string; bar: string }> = {
  weapon: { border: "border-slot-weapon", bar: "bg-slot-weapon" },
  vitality: { border: "border-slot-vitality", bar: "bg-slot-vitality" },
  spirit: { border: "border-slot-spirit", bar: "bg-slot-spirit" },
};
